export function ConditionsSwitch(condition, temp, value, row) {
    switch (condition) {
        case '>':
            if (temp > value) {
                row["isActive"] = true;
            }
            break;
        case '<':
            if (temp < value) {
                row["isActive"] = true;
            }
            break;
        case '=':
            if (temp == value) {
                row["isActive"] = true;
            }
            break;
        case '!=':
            if (temp != value) {
                row["isActive"] = true;
            }
            break;
        default:
            row["isActive"] = false;
            break;
    }

}